export default {
    name: 'UpdateResume',
    props: {
        resume: {
            type: Object
        }
    }
};
